import React from "react";
import { WHATSAPP_URL } from "../constants";

const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="wa-float"
    aria-label="Habla por WhatsApp"
  >
    <svg
      width="30"
      height="30"
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.003 3C9.374 3 4 8.375 4 15.004c0 2.357.681 4.553 1.852 6.4L4 29l7.79-1.797A11.94 11.94 0 0 0 16.003 27C22.632 27 28 21.625 28 14.996 28 8.376 22.632 3 16.003 3Zm0 21.998c-1.97 0-3.808-.553-5.375-1.504l-.385-.232-4.622 1.066 1.083-4.51-.25-.4a9.927 9.927 0 0 1-1.59-5.418c0-5.523 4.495-10.018 10.139-10.018 5.643 0 10.138 4.495 10.138 10.018 0 5.523-4.495 10.998-9.138 10.998Zm5.567-7.49c-.304-.152-1.796-.886-2.073-.987-.278-.101-.48-.152-.683.152-.202.304-.78.987-.957 1.189-.176.202-.353.228-.657.076-.304-.152-1.285-.473-2.448-1.508-.905-.806-1.515-1.802-1.694-2.107-.176-.304-.019-.469.134-.62.137-.137.304-.355.456-.532.152-.176.202-.304.304-.506.101-.202.05-.38-.025-.532-.076-.152-.683-1.646-.936-2.253-.246-.591-.497-.511-.683-.521-.176-.008-.38-.01-.582-.01a1.118 1.118 0 0 0-.81.38c-.278.304-1.062 1.038-1.062 2.531s1.087 2.937 1.239 3.139c.152.202 2.139 3.27 5.186 4.586.725.313 1.29.5 1.732.64.728.232 1.391.2 1.914.121.584-.087 1.796-.733 2.05-1.44.253-.708.253-1.314.176-1.44-.076-.126-.279-.202-.582-.354Z"/>
    </svg>
  </a>
);

export default WhatsAppFloat;
